import React, { PureComponent } from 'react';
import './SummaryTable.css';

class SummaryTable extends PureComponent {

  render() {
    const { data2,
    } = this.props

    function setQtrs(time) {
      let d = new Date();
      // var d = new Date('2021-01-02');
      var quarter = Math.floor((d.getMonth() / 3) + 1);
      var firstDate = '';
      var endDate = '';
      var calYear = '';
      // var endMonth = '';
      var qtrNum = '';
      switch (time) {
        case "PrevCalYr":
          firstDate = new Date(d.getFullYear() - 1, 0, 1);
          endDate = new Date(firstDate.getFullYear(), 11, 31);
          calYear = firstDate.getFullYear();
          qtrNum = quarter
          break;
        case "Q1":
          firstDate = new Date(d.getFullYear(), 0, 1);
          endDate = new Date(firstDate.getFullYear(), 2, 31);
          calYear = firstDate.getFullYear();
          qtrNum = 'Q1'//getQtrNum(endMonth);
          break;
        case "Q2":
          firstDate = new Date(d.getFullYear(), 3, 1);
          endDate = new Date(firstDate.getFullYear(), 5, 30);
          calYear = firstDate.getFullYear();
          qtrNum = 'Q2'//getQtrNum(endMonth);
          break;
        case "Q3":
          firstDate = new Date(d.getFullYear(), 6, 1);
          endDate = new Date(firstDate.getFullYear(), 8, 30);
          calYear = firstDate.getFullYear();
          qtrNum = 'Q3'//getQtrNum(endMonth);
          break;
        case "Q4":
          firstDate = new Date(d.getFullYear(), 9, 1);
          endDate = new Date(firstDate.getFullYear(), 11, 31);
          calYear = firstDate.getFullYear();
          qtrNum = 'Q4'//getQtrNum(endMonth);
          break;
      }
      return ([firstDate, endDate, calYear, qtrNum])
    }


    function inRange(start, end, checkdate) {

      let cc = new Date(end.getTime());   // clone the date to not muck the original value
      cc.setDate(cc.getDate() + 1);        // add a day
      var hide = checkdate >= start && checkdate < cc; // use a half-open interval

      return hide;
    }
    const sortedData = data2.slice().sort((a, b) => a.date - b.date)

    const firstDate = sortedData[0].date;
    let lastDate = new Date(sortedData[sortedData.length - 1].date)

    let Q1 = setQtrs('Q1')
    let Q2 = setQtrs('Q2')
    let Q3 = setQtrs('Q3')
    let Q4 = setQtrs('Q4')
    let PCY = setQtrs('PrevCalYr')


    //test 
    //let dt = new Date()
    let dt = new Date(lastDate);

    let hideTable = false;

    let showQ1 = false;
    let showQ2 = false;
    let showQ3 = false;
    // let showQ4 = false;
    let showPCY = false;
    // let showTable = true;

    // const wtFundStartDt = new Date('2006-06-23')

    const startDtBefQ1 = inRange(firstDate, PCY[1], firstDate)
    const startDtBefQ2 = inRange(firstDate, Q1[1], firstDate)
    const startDtBefQ3 = inRange(firstDate, Q2[1], firstDate)
    const startDtBefQ4 = inRange(firstDate, Q3[1], firstDate)

    const currinQ1 = inRange(Q1[0], Q1[1], dt)
    const currinQ2 = inRange(Q2[0], Q2[1], dt)
    const currinQ3 = inRange(Q3[0], Q3[1], dt)
    const currinQ4 = inRange(Q4[0], Q4[1], dt)

    const startQ1 = inRange(Q1[0], Q1[1], firstDate)
    const startQ2 = inRange(Q2[0], Q2[1], firstDate)
    const startQ3 = inRange(Q3[0], Q3[1], firstDate)
    const startQ4 = inRange(Q4[0], Q4[1], firstDate)



    if (currinQ1 && startDtBefQ1) {
      showPCY = true
    }
    if (currinQ2 && startDtBefQ2) {
      showQ1 = true;
    }
    if (currinQ3 && startDtBefQ3) {
      showQ1 = true;
      showQ2 = true;
    }

    if (currinQ4 && startDtBefQ4) {
      showQ1 = true;
      showQ2 = true;
      showQ3 = true;
    }
    if (startDtBefQ1) {
      showPCY = true;
    }
    if (startQ1) {
      showPCY = false
    }
    if (startQ2) {
      showQ1 = false;
    }
    if (startQ3) {
      showQ1 = false;
      showQ2 = false;
    }
    if (startQ4) {
      showQ1 = false;
      showQ2 = false;
      showQ3 = false;
      hideTable = true;
    }

    // hide table anytie start date is in same qtr as current QTR
    if ((currinQ1 && startQ1) || (currinQ2 && startQ2) || (currinQ3 && startQ3) || (currinQ4 && startQ4)) {
      hideTable = true;
    }


    var prevYearData = sortedData.filter(function (x) {
      return (x.date >= PCY[0] && x.date < PCY[1]);
    });

    var Q1Data = sortedData.filter(function (x) {
      return (x.date >= Q1[0] && x.date < Q1[1]);
    });

    var Q2Data = sortedData.filter(function (x) {
      return (x.date >= Q2[0] && x.date < Q2[1]);
    });

    var Q3Data = sortedData.filter(function (x) {
      return (x.date >= Q3[0] && x.date < Q3[1]);
    });

    // var Q4Data = sortedData.filter(function (x) {
    //   return (x.date >= Q4[0] && x.date < Q4[1]);
    // });


    function getCounts(data) {
      var above = 0;
      var below = 0;
      for (let j = 0; j < data.length; j++) {
        if (data[j].BpsDiff >= 0) {
          above += 1
        } else {
          below += 1
        }
      }
      return ([above, below])
    }

    let Q1Counts = getCounts(Q1Data)
    let Q2Counts = getCounts(Q2Data)
    let Q3Counts = getCounts(Q3Data)
    //  let Q4Counts = getCounts(Q4Data)
    let PCYCounts = getCounts(prevYearData)


    if (hideTable === false) {
      return (
        <div >
          <br /><br />
          <div>
            <table id='resp-table' >
              <thead className='resp-table-header' >
                <tr >
                  <th colSpan='3' className='table-header-cell' ></th>
                  {(showPCY) &&
                    <th colSpan='1' className='table-header-cell' >{PCY[2]} </th>
                  }
                  {(showQ1) &&
                    <th colSpan='1' className='table-header-cell' >{Q1[3]}  </th>
                  }
                  {(showQ2) &&
                    <th colSpan='1' className='table-header-cell' >{Q2[3]}  </th>
                  }
                  {(showQ3) &&
                    <th colSpan='1' className='table-header-cell' >{Q3[3]}  </th>
                  }
                </tr>
              </thead>
              <tbody className='resp-table-body'>
                <tr className='resp-table-row'>
                  <td colSpan='3' className='table-body-cell-left' >Days traded at a premium </td>
                  {(showPCY) &&
                    <td className='table-body-cell'>{PCYCounts[0]} </td>
                  }
                  {(showQ1) &&
                    <td className='table-body-cell'>{Q1Counts[0]} </td>
                  }
                  {(showQ2) &&
                    <td className='table-body-cell'>{Q2Counts[0]} </td>
                  }
                  {(showQ3) &&
                    <td className='table-body-cell'>{Q3Counts[0]} </td>
                  }
                </tr>
                <tr className='resp-table-row-odd'>
                  <td colSpan='3' className='table-body-cell-left' >Days traded at a discount</td>
                  {(showPCY) &&
                    <td className='table-body-cell'>{PCYCounts[1]} </td>
                  }
                  {(showQ1) &&
                    <td className='table-body-cell'>{Q1Counts[1]} </td>
                  }
                  {(showQ2) &&
                    <td className='table-body-cell'>{Q2Counts[1]} </td>
                  }
                  {(showQ3) &&
                    < td className='table-body-cell'>{Q3Counts[1]} </td>
                  }
                </tr>
              </tbody>
            </table>
          </div>
        </div >
      )
    }
    else return null;
  }
}

export default SummaryTable


// WEBPACK FOOTER //
// ./src/SummaryTable.js